import axios from "axios";
import auth from "../auth/auth";
import authDir from "../auth/authDirecto";
import store from "@/store";

const baseUrl = process.env.VUE_APP_API_URL;
const api = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Credentials": true,
    "ngrok-skip-browser-warning": "1234"
  }
});
api.interceptors.request.use(async (config) => {
  let token = null;
  let tokenDir = null;
  if (auth.isAuthenticated()) {
    token = auth.getUserLogged()?.token;
  }
  if (authDir.isAuthenticated()) {
    tokenDir = authDir.getUserLogged()?.token;
  }
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  if (tokenDir) {
    config.headers["authorization-payment"] = "Bearer " + tokenDir;
  }
  return config;
});
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("error: ", error);
    // if (error.response.status == 429) {
    // store.dispatch("mostrarAlerta", {
    //   mensaje: error.response.data,
    //   color: "error"
    // });
    // }

    if (error.response.status === 401) {
      store.dispatch("mostrarAlerta", {
        mensaje: "Su sesión ha expirado, por favor vuelva a iniciar sesión.",
        color: "error"
      });
      auth.cerrarSesion();
    }
    return Promise.reject(error);
  }
);
export default api;
